module.exports = __webpack_public_path__ + "static/media/header.bd272eb9.svg";